var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 220,
    viewBox: "0 0 200 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0H176C189.255 0 200 10.7452 200 24V196C200 209.255 189.255 220 176 220H24C10.7452 220 0 209.255 0 196V24Z",
    fill: "#7C5AC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9685 68.0811C55.6349 67.7238 54.264 68.5152 53.9067 69.8489L39.6716 122.975C39.3143 124.308 40.1057 125.679 41.4394 126.037L138.032 151.919C139.366 152.276 140.736 151.484 141.094 150.151L155.329 97.0249C155.686 95.6912 154.895 94.3204 153.561 93.963L56.9685 68.0811ZM116.819 115.176C113.96 125.845 102.993 132.177 92.3238 129.318C81.6545 126.459 75.3229 115.493 78.1817 104.823C81.0405 94.1541 92.0073 87.8224 102.677 90.6812C113.346 93.5401 119.678 104.507 116.819 115.176Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5 80C46.1193 80 45 81.1193 45 82.5V137.5C45 138.881 46.1193 140 47.5 140H147.5C148.881 140 150 138.881 150 137.5V82.5C150 81.1193 148.881 80 147.5 80H47.5ZM117.5 110C117.5 121.046 108.546 130 97.5 130C86.4543 130 77.5 121.046 77.5 110C77.5 98.9543 86.4543 90 97.5 90C108.546 90 117.5 98.9543 117.5 110ZM97.5 120C103.023 120 107.5 115.523 107.5 110C107.5 104.477 103.023 100 97.5 100C91.9772 100 87.5 104.477 87.5 110C87.5 115.523 91.9772 120 97.5 120Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.b3029980.svg";
export { ForwardRef as ReactComponent };